(function () {
  if (window.TownWineExchangeRate && window.TownWineExchangeRate.__initialized) {
    return;
  }

  var DEFAULT_RATE = 180;
  var STORAGE_KEY = 'townwine-hkd-krw-rate-v1';
  var REFRESH_INTERVAL_MS = 7 * 24 * 60 * 60 * 1000;
  var DEFAULT_PROXY_BASE = '/apps/townwine-follow';

  function normalizeRate(value) {
    var parsedValue = Number(value);
    return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : DEFAULT_RATE;
  }

  function formatKrwFromHkdCents(priceCents, rate) {
    var amount = (Number(priceCents || 0) / 100) * normalizeRate(rate);
    return 'KRW \u20a9' + Math.round(amount).toLocaleString('ko-KR');
  }

  function getConfig() {
    return Object.assign(
      {
        proxyBase: DEFAULT_PROXY_BASE,
        shop: '',
      },
      window.TownWineExchangeRateConfig || {},
    );
  }

  function readStoredSnapshot() {
    try {
      var rawValue = window.localStorage.getItem(STORAGE_KEY);

      if (!rawValue) {
        return null;
      }

      var parsedValue = JSON.parse(rawValue);
      var updatedAt = String(parsedValue && parsedValue.updatedAt ? parsedValue.updatedAt : '').trim();
      var updatedTimestamp = updatedAt ? new Date(updatedAt).getTime() : 0;

      if (!updatedTimestamp || Date.now() - updatedTimestamp > REFRESH_INTERVAL_MS) {
        return null;
      }

      return {
        rate: normalizeRate(parsedValue.rate),
        updatedAt: updatedAt,
        source: String(parsedValue.source || 'cache'),
        referenceDate: String(parsedValue.referenceDate || ''),
      };
    } catch (error) {
      return null;
    }
  }

  function writeStoredSnapshot(snapshot) {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          rate: normalizeRate(snapshot.rate),
          updatedAt: snapshot.updatedAt || new Date().toISOString(),
          source: snapshot.source || 'cache',
          referenceDate: snapshot.referenceDate || '',
        }),
      );
    } catch (error) {
      // Ignore storage failures.
    }
  }

  function setGlobalSnapshot(snapshot) {
    var nextSnapshot = Object.assign({}, window.TownWineExchangeRate || {}, snapshot || {});
    nextSnapshot.rate = normalizeRate(nextSnapshot.rate);
    nextSnapshot.__initialized = true;
    window.TownWineExchangeRate = nextSnapshot;
    return nextSnapshot;
  }

  function dispatchSnapshot(snapshot) {
    window.dispatchEvent(
      new CustomEvent('townwine:exchange-rate-updated', {
        detail: snapshot,
      }),
    );
  }

  function applyRateToVariantOptions(rate) {
    Array.prototype.slice.call(document.querySelectorAll('.tw-option-input[data-hkd-price-cents]')).forEach(
      function (input) {
        var nextPriceKrw = formatKrwFromHkdCents(input.dataset.hkdPriceCents, rate);
        input.dataset.priceKrw = nextPriceKrw;

        var pill = input.nextElementSibling;
        var priceSub =
          pill instanceof HTMLElement ? pill.querySelector('.opt__pill__price-sub') : null;

        if (priceSub instanceof HTMLElement) {
          priceSub.textContent = nextPriceKrw;
        }

        if (input.checked) {
          var mainPriceKrw = document.querySelector('[data-price-krw]');

          if (mainPriceKrw instanceof HTMLElement) {
            mainPriceKrw.textContent = nextPriceKrw;
          }
        }
      },
    );
  }

  function applyRateToDom(rate) {
    Array.prototype.slice.call(
      document.querySelectorAll('[data-krw-price-target][data-hkd-price-cents]'),
    ).forEach(function (node) {
      node.textContent = formatKrwFromHkdCents(node.dataset.hkdPriceCents, rate);
    });

    applyRateToVariantOptions(rate);
  }

  function buildRequestUrl() {
    var config = getConfig();
    var params = new URLSearchParams();

    if (config.shop) {
      params.set('shop', String(config.shop).trim());
    }

    return config.proxyBase + '/exchange-rate' + (params.toString() ? '?' + params.toString() : '');
  }

  async function refreshSnapshot() {
    var response = await fetch(buildRequestUrl(), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('EXCHANGE_RATE_REQUEST_FAILED');
    }

    var payload = await response.json();

    return {
      rate: normalizeRate(payload && payload.rate),
      updatedAt:
        String((payload && payload.updatedAt) || '').trim() || new Date().toISOString(),
      source: String((payload && payload.source) || 'api').trim() || 'api',
      referenceDate: String((payload && payload.referenceDate) || '').trim(),
    };
  }

  var storedSnapshot = readStoredSnapshot();
  var initialSnapshot = storedSnapshot || {
    rate: DEFAULT_RATE,
    updatedAt: '',
    source: storedSnapshot ? storedSnapshot.source : 'fallback',
    referenceDate: '',
  };

  setGlobalSnapshot(initialSnapshot);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyRateToDom(initialSnapshot.rate);
    });
  } else {
    applyRateToDom(initialSnapshot.rate);
  }

  refreshSnapshot()
    .then(function (nextSnapshot) {
      writeStoredSnapshot(nextSnapshot);
      setGlobalSnapshot(nextSnapshot);
      applyRateToDom(nextSnapshot.rate);
      dispatchSnapshot(window.TownWineExchangeRate);
    })
    .catch(function (error) {
      console.warn('[townwine-exchange-rate] failed to refresh rate', error);
    });
})();

